import { render, staticRenderFns } from "./port-name-list.vue?vue&type=template&id=79659171"
import script from "./port-name-list.vue?vue&type=script&lang=js"
export * from "./port-name-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports